import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.recruitments.rejections');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-recruitments-rejections',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.recruitments.rejections/view.scss */
/* src/app/page.recruitments.rejections/view.scss: no such file or directory */`],
})
export class PageRecruitmentsRejectionsComponent implements OnInit {
    public id: string = "";
    public loading: boolean = true;
    public savingPolicy: boolean = false;
    public savingEligibilityId: string = "";
    public payload: any = null;
    public items: any[] = [];
    public permissions: any = {};
    public uiPolicy: any = {
        solo_admin_mode: true,
        solo_admin_applies: false
    };
    public policy: any = null;
    public accessError: string = "";
    public filters: any = {
        reason_category: "",
        reapply_allowed: ""
    };
    public policyForm: any = {
        default_reapply_allowed: "true",
        cooling_period_days: 0,
        policy_note: ""
    };
    public eligibilityForms: any = {};
    public booleanOptions: any[] = [
        { key: "", label: "전체" },
        { key: "true", label: "가능" },
        { key: "false", label: "불가" },
    ];

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadPolicy();
        await this.load();
    }

    public async loadPolicy() {
        const { code, data } = await wiz.call("get_reapplication_policy", {
            id: this.id,
            recruitment_id: this.id
        });
        if (code === 200 && data?.policy) {
            this.policy = data.policy;
            this.permissions = { ...this.permissions, ...(data.permissions || {}) };
            this.updateUiPolicy(data);
            this.policyForm = {
                default_reapply_allowed: String(!!data.policy.default_reapply_allowed),
                cooling_period_days: data.policy.cooling_period_days || 0,
                policy_note: ""
            };
        }
    }

    public async load() {
        this.loading = true;
        this.accessError = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("list_rejected_applicants", {
            id: this.id,
            recruitment_id: this.id,
            reason_category: this.filters.reason_category,
            reapply_allowed: this.filters.reapply_allowed
        });
        if (code === 200 && data?.ok !== false) {
            this.payload = data;
            this.items = data.items || [];
            this.permissions = { ...this.permissions, ...(data.permissions || {}) };
            this.updateUiPolicy(data);
            this.seedEligibilityForms();
        } else {
            this.payload = null;
            this.items = [];
            this.accessError = this.safeErrorMessage(code, message || data?.message, "불합격 지원자 목록 조회 중 오류가 발생했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public seedEligibilityForms() {
        for (const item of this.items) {
            this.eligibilityForms[item.applicant_id] = {
                reapply_allowed: String(!!item.reapply_allowed),
                available_from: item.available_from || "",
                reason: ""
            };
        }
    }

    public reasonCategories() {
        return [{ key: "", label: "전체" }, ...(this.payload?.reason_categories || [])];
    }

    public canManagePolicy() {
        return !!this.permissions?.can_manage_reapplication_policy;
    }

    public canConfirmOutcome() {
        return !!this.permissions?.can_confirm_outcome;
    }

    public updateUiPolicy(data: any) {
        const policy = data?.ui_policy || data?.permissions?.ui_policy || null;
        if (policy) this.uiPolicy = { ...this.uiPolicy, ...policy };
    }

    public soloAdminMode() {
        return !!this.uiPolicy?.solo_admin_mode && !!this.uiPolicy?.solo_admin_applies;
    }

    public compactStatusLabel(label: any) {
        const text = String(label || "").trim();
        if (!text) return "";
        if (text.includes("권한")) return text;
        if (/담당자 확인 필요|관리자 확인 필요|관리자 확정 필요|수동검토 필요|기준 확정 필요/.test(text)) return "확인 필요";
        if (text.includes("최종 미확정")) return "미확정";
        return text;
    }

    public async applyFilters() {
        await this.load();
    }

    public async resetFilters() {
        this.filters = { reason_category: "", reapply_allowed: "" };
        await this.load();
    }

    public async savePolicy() {
        if (this.savingPolicy || !this.canManagePolicy()) return;
        this.savingPolicy = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("update_reapplication_policy", {
            id: this.id,
            recruitment_id: this.id,
            default_reapply_allowed: this.policyForm.default_reapply_allowed,
            cooling_period_days: this.policyForm.cooling_period_days || 0,
            policy_note: this.policyForm.policy_note || ""
        });
        this.savingPolicy = false;

        if (code === 200 && data?.ok !== false) {
            this.policy = data.policy;
            this.policyForm.policy_note = "";
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "재지원 정책 저장 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async saveEligibility(item: any) {
        if (!item?.applicant_id || this.savingEligibilityId || !this.canConfirmOutcome()) return;
        const form = this.eligibilityForms[item.applicant_id] || {};
        this.savingEligibilityId = item.applicant_id;
        await this.service.render();

        const { code, data, message } = await wiz.call("update_reapplication_eligibility", {
            applicant_id: item.applicant_id,
            reapply_allowed: form.reapply_allowed,
            available_from: form.available_from || "",
            reason: form.reason || ""
        });
        this.savingEligibilityId = "";

        if (code === 200 && data?.ok !== false) {
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "재지원 가능 여부 저장 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public openDetail(item: any) {
        if (!item?.detail_url) return;
        location.href = item.detail_url;
    }

    public safeErrorMessage(code: number, message: string, fallback: string) {
        if (code === 403) return "권한이 필요합니다.";
        const text = String(message || "").trim();
        if (!text || /Traceback|File \"|\/opt\/|storage_key|file_path|<html/i.test(text)) return fallback;
        return text.length > 140 ? `${text.slice(0, 140).trim()}...` : text;
    }

    public badgeClass(status: any) {
        const value = String(status || "");
        if (value === "true" || value === "ALLOWED" || value === "CONFIRMED") return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (value === "false" || value === "NOT_ALLOWED" || value === "REJECTED") return "bg-rose-50 text-rose-700 border border-rose-200";
        if (value === "PENDING" || value === "ON_HOLD") return "bg-amber-50 text-amber-700 border border-amber-200";
        return "bg-zinc-50 text-zinc-600 border border-zinc-200";
    }
}

export default PageRecruitmentsRejectionsComponent;